export default __webpack_public_path__ + "static/1.2-Text-alternatives-DO_4-b8636706f983d21721b970507d81016e.png";